var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-height pa-1",attrs:{"id":"video-upload"}},[_c('file-pond',_vm._b({ref:"filepond",on:{"init":_vm.handleFilepondInit,"addfilestart":_vm.handleFilepondAddFileStart}},'file-pond',_vm.filepondOptions,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }